<template>
    <v-container>
        <v-card outlined>
            <v-card-title class="mb-3 primary white--text py-6">
                <span class="mx-auto"> Current Vehicle Details </span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col class="grow">
                        <v-row class="my-0 mb-n2">
                            <v-col class="py-0" cols="3">
                                <v-subheader>Year</v-subheader>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    hide-details
                                    class="mb-0"
                                    :value="vehicle.year"
                                    readonly
                                    filled
                                    dense
                                />
                            </v-col>
                        </v-row>
                        <v-row class="my-0 mb-n2">
                            <v-col class="py-0" cols="3">
                                <v-subheader>Brand</v-subheader>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    hide-details
                                    class="mb-0"
                                    :value="vehicle.brand"
                                    readonly
                                    filled
                                    dense
                                />
                            </v-col>
                        </v-row>
                        <v-row class="my-0 mb-n2">
                            <v-col class="py-0" cols="3">
                                <v-subheader>Range</v-subheader>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    hide-details
                                    class="mb-0"
                                    :value="vehicle.range"
                                    readonly
                                    filled
                                    dense
                                />
                            </v-col>
                        </v-row>
                        <v-row class="my-0 mb-n2">
                            <v-col class="py-0" cols="3">
                                <v-subheader>Model</v-subheader>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    hide-details
                                    class="mb-0"
                                    :value="vehicle.model"
                                    readonly
                                    filled
                                    dense
                                />
                            </v-col>
                        </v-row>
                        <v-row class="my-0 mb-n2">
                            <v-col class="py-0" cols="3">
                                <v-subheader>Fuel Type</v-subheader>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    hide-details
                                    class="mb-0"
                                    :value="vehicle.fuelType"
                                    readonly
                                    filled
                                    dense
                                />
                            </v-col>
                        </v-row>
                        <v-row class="my-0 mb-n2">
                            <v-col class="py-0" cols="3">
                                <v-subheader>Transmission Type</v-subheader>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    hide-details
                                    class="mb-0"
                                    :value="vehicle.transmissionType"
                                    readonly
                                    filled
                                    dense
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="shrink">
                        <div class="smc-card-avatar" style="width: 320px">
                            <img
                                :src="vehicle.imageUrl"
                                class="smc-search-result-image"
                            />
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <quote-price-item-lookup
            class="mt-6"
            :quoteRequestSearchMode="true"
            :quoteRequestProp="resolvedQuoteRequest"
            :initialSearchTerms="initialSearchTerms"
            :itemsLoading="loading"
        />
    </v-container>
</template>

<script>
import quotePriceItemLookup from '@/components/quote-price-item-lookup';
import { quoteRequestService, userService } from '@/services';

export default {
    name: 'quote-price-lookup',
    components: {
        quotePriceItemLookup,
    },
    props: {
        quoteRequestProp: Object,
    },
    data: () => ({
        loading: false,
        quoteRequestItems: [],
        fetchedVehicle: null,
    }),
    computed: {
        resolvedQuoteRequest() {
            if (!this.fetchedVehicle) {
                return this.quoteRequestProp;
            }
            return {
                ...this.quoteRequestProp,
                vehicle: { ...this.quoteRequestProp.vehicle, ...this.fetchedVehicle },
            };
        },
        vehicle() {
            return this.resolvedQuoteRequest.vehicle || {};
        },
        initialSearchTerms() {
            return this.quoteRequestItems.map(item => item.name);
        },
    },
    async created() {
        await this.loadQuoteRequestItem();
    },
    methods: {
        async loadQuoteRequestItem() {
            let vehicle = this.quoteRequestProp.vehicle;
            let items = this.quoteRequestProp.items;
            let vehicleComplete = !!(
                vehicle
                && vehicle.fuelType
                && vehicle.capacity
                && vehicle.brandCode
                && vehicle.rangeCode
            );
            let hasItems = !!(items && items.length > 0);

            if (hasItems) {
                this.quoteRequestItems = items;
            }
            if (vehicleComplete && hasItems) {
                return;
            }

            // Only fetch what the passed-in quote request is missing.
            this.loading = true;
            await Promise.all([
                hasItems ? null : this.loadItems(),
                vehicleComplete ? null : this.loadVehicle(),
            ]);
            this.loading = false;
        },
        async loadItems() {
            let quoteRequest = await quoteRequestService.getQuoteRequest(
                this.quoteRequestProp.uniqueId,
            );
            if (quoteRequest && quoteRequest.items) {
                this.quoteRequestItems = quoteRequest.items;
            }
        },
        async loadVehicle() {
            let vehicleId = this.quoteRequestProp.vehicleId
                || (this.quoteRequestProp.vehicle && this.quoteRequestProp.vehicle.id);
            if (!vehicleId) {
                return;
            }

            // The backend returns the vehicle for this id when the filter is "ID:<vehicleId>".
            let result = await userService.getVehicles({
                filter: `ID:${vehicleId}`,
                page: 1,
                itemsPerPage: 1,
            });
            let mapping = result && result.data && result.data.items && result.data.items[0];
            if (mapping && mapping.vehicle) {
                this.fetchedVehicle = mapping.vehicle;
            }
        },
    },
};
</script>

<style>
</style>
